/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Logger, LoggerInterface } from "../Logger";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "bloom",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Message",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "bloom",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "callDataOnly",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "bloom",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "log",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "blooms",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "logMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Logger__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Logger> {
    return super.deploy(overrides || {}) as Promise<Logger>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Logger {
    return super.attach(address) as Logger;
  }
  connect(signer: Signer): Logger__factory {
    return super.connect(signer) as Logger__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LoggerInterface {
    return new utils.Interface(_abi) as LoggerInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Logger {
    return new Contract(address, _abi, signerOrProvider) as Logger;
  }
}
